<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('operators.details.name') }}</label></td>
      <td>{{ details.name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('operators.details.fare_group_id') }}</label></td>
      <td><router-link v-if="details.fare_group_id" :to="fareGroupLink(details)">{{ details.fare_group_id }}</router-link></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('operators.details.settings') }}</label></td>
      <td><operator-settings-details v-if="details.settings" :details="details.settings"/></td>
    </tr>
  </table>
</template>
<script>

import linkUtils from "@/util/link_utils";
import OperatorSettingsDetails   from "@/components/Operator/OperatorSettingsDetails.vue";

export default {
  name: 'operatorDetails',
  components: {
    OperatorSettingsDetails
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    fareGroupLink(row) {
      return linkUtils.fareGroupPath(this.$router, {fare_group_id: row.fare_group_id});
    }
  }
};
</script>
